<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div
          v-show="stateArrow"
          id="leftBox"
          class="leftBox"
          style="width: 206px"
        >
          <vue-draggable-resizable
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <el-scrollbar>
              <tree
                :isSearch="isSearch"
                @initFun="initQuery"
                @nodeClick="nodeClick"
              ></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i
            :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"
          ></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item :label="$t('common.driverNum')">
                    <el-input
                      size="mini"
                      v-model="formInline.driverNum"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('common.driverName')">
                    <el-input
                      size="mini"
                      v-model="formInline.name"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('DriverManagement.driverExpiresType')"
                  >
                    <el-select
                      v-model="formInline.driverExpiresType"
                      :placeholder="$t('DriverManagement.driverExpiresType')"
                      filterable
                      size="mini"
                      style="width: 120px"
                    >
                      <el-option
                        v-for="item in StateList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('DriverManagement.driverExpires')">
                    <el-date-picker
                      v-model="formInline.driverExpiresTime"
                      type="daterange"
                      style="width: 220px"
                      size="mini"
                      value-format="yyyy-MM-dd"
                      range-separator
                      start-:placeholder="$t('common.search.dateSearch')"
                      end-placeholder
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{ $t("common.btn.search") }}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del"
                      >{{ $t("common.btn.cancel") }}
                    </el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button
                  v-if="isPrimaryKey('DRIVERANNUALREVIEW_DRIVERANNUALREVIEW')"
                  type="text"
                  :disabled="selected.length != 1"
                  @click="carAnnualReview"
                  >{{ $t("NavMenu.DriverAnnualReview") }}
                </el-button>
                <el-button
                  v-if="isPrimaryKey('DRIVERANNUALREVIEW_APPROVALPROGRESS')"
                  type="text"
                  :disabled="selected.length != 1"
                  @click="ApprovalProgress"
                  >{{ $t("DriverManagement.approvalProgress") }}
                </el-button>
                <el-button
                  v-if="isPrimaryKey('DRIVERANNUALREVIEW_DOWN')"
                  type="text"
                  @click="downCar"
                  >{{ $t("common.btn.download") }}
                </el-button>
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="800px"
        :before-close="closeDia"
        class="carDialong"
        :title="$t('NavMenu.DriverAnnualReview')"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            prop="driverNum"
            :label="$t('common.driverNum') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.driverNum"
              autocomplete="off"
              :disabled="disabled"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="name"
            :label="$t('common.driverName') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.name"
              autocomplete="off"
              :disabled="disabled"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="nowExpireDate"
            :label="$t('DriverManagement.nowExpireDate') + ':'"
            :label-width="formLabelWidth"
          >
            <el-date-picker
              :disabled="disabled"
              value-format="yyyy-MM-dd"
              type="date"
              :placeholder="$t('common.search.dateSearch')"
              v-model="form.nowExpireDate"
              style="width: 500px"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            prop="changeExpireDate"
            :label="$t('DriverManagement.changeExpireDate') + ':'"
            :label-width="formLabelWidth"
          >
            <el-date-picker
              value-format="yyyy-MM-dd"
              type="date"
              :placeholder="$t('common.search.dateSearch')"
              v-model="form.changeExpireDate"
              style="width: 500px"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            prop="filePath"
            :label="$t('common.picture') + ':'"
            :label-width="formLabelWidth"
            style="width: 340px"
          >
            <el-upload
              class="picStyle"
              :action="processImg"
              :show-file-list="false"
              :file-list="FileList"
              :on-success="handleAvatarSuccess"
              :on-remove="handleRemove"
            >
              <img v-if="imageUrl" :src="imageUrl" class="avatars" />
              <i v-else class="el-icon-plus avatars-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')">{{
            $t("common.btn.confirm")
          }}</el-button>
        </div>
      </el-dialog>
      <el-dialog
        width="1200px"
        :before-close="closeOperateDia"
        class="tableDialong"
        :title="$t('DriverManagement.approvalProgress')"
        :visible.sync="dialogOperateFormVisible"
        :close-on-click-modal="false"
      >
        <div class="zMsgBtn">
          <el-button
            type="text"
            :disabled="select.length != 1"
            @click="reAnnualReview"
            >{{ $t("DriverManagement.annualAgain") }}</el-button
          >
        </div>
        <div class="zMsgTable">
          <i-table
            :list="operatesList"
            :height="operatesHeight"
            ref="operatesTable"
            @handleSelectionChange="handleOperatesChange"
            :options="option"
            :columns="allColumns"
            :operates="allOperates"
          ></i-table>
          <IPagination
            ref="OperatesPage"
            @PageFun="changeOperatesSize"
          ></IPagination>
        </div>
      </el-dialog>
      <el-dialog
        width="90%"
        class="tableDialong"
        :before-close="closeImgDia"
        :title="$t('common.picture')"
        :visible.sync="dialogImgFormVisible"
      >
        <img :src="imgUrl" style="width: 100%" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import DriverAnnualReview from "./DriverAnnualReview.js";
export default DriverAnnualReview;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
